var map = {
	"./dark.css": [
		584
	],
	"./light.css": [
		2566,
		18
	],
	"./variables.css": [
		583
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1191;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/styles/theme lazy ^\.\/.*\.css$
// module id = 1191
// module chunks = 19